import {
    PartidoAlineacionesPage,
    getStaticPaths,
    getStaticProps,
} from '@/components/alineaciones/partido/PartidoAlineacionesPageHelper';

export { getStaticPaths, getStaticProps };

export default function AlineacionesProbablesPage(props) {
    return <PartidoAlineacionesPage {...props} />;
}
